<template>
	<div>
		<!-- alert para cuando el reporte no encuentra resultados -->
		<CRow class="justify-content-center">
			<CCol md="12">
				<CAlert
					:show.sync="dismissCountDown"
					closeButton
					color="info"
					fade
				>
					<p>
						No se encontraron envíos para:
						<b>{{ selectedClient.nombre_comercial }}</b
						>.
					</p>
					<p>
						<small
							>Este aviso se cerrará automáticamente en
							<b>{{ dismissCountDown }}</b> segundos ...</small
						>
					</p>
				</CAlert>
			</CCol>
		</CRow>
		<CRow class="justify-content-center">
			<CCol md="12">
				<CCard>
					<CCardHeader style="background: #97ca3d;color: #000000;">
						<h4>Reporte de Solicitudes por Empresa</h4>
					</CCardHeader>
					<CCardBody>
						<!-- autocompletado para seleccionar la empresa -->
						<div v-if="showFilter">
							<CRow>
								<CCol>
									<span class="float-left">
										<p>
											Para realizar el reporte debes
											eleguir una empresa en el siguiente
											autocompletado.
										</p>
									</span>
								</CCol>
							</CRow>
							<CRow>
								<CCol>
									<autocomplete
										:search="search"
										placeholder="Ingresa el Nombre de la Empresa"
										aria-label="Nombre de la empresa"
										:get-result-value="getResultValue"
										@submit="onSubmit"
									></autocomplete>
								</CCol>
							</CRow>
						</div>
						<!-- sección para mostrar el reporte -->
						<div v-if="showReport">
							<table-for-reports
								:fields-table="fieldsTableReport"
								:table="tableForReport"
								:total-rows="totalRows"
							/>
							<CRow class="content-center">
								<CCol sm="6">
									<export-excel
										:data-to-export="dataToExport"
										file-name="Solicitudes por Empresas"
									/>
								</CCol>
								<CCol sm="6">
									<b-button
										@click="generateNewReport"
										style="margin-top: 10px;"
										pill
										variant="success"
									>
										Generar Otro Reporte</b-button
									>
								</CCol>
							</CRow>
						</div>
					</CCardBody>
				</CCard>
			</CCol>
		</CRow>
	</div>
</template>

<script>
	import FilterReports from '../../components/filterReports.vue';
	import functionsReports from '../../functions/functionsForReports';
	import exportExcel from '../../components/exportExcel';
	import tableForReports from '../../components/tableForReports';
	/*Componente para el reporte de envíos por empresa. */
	export default {
		name: 'requestsByBussiness',
		title: 'Reporte por Empresas | Infoguia',
		components: {
			FilterReports,
			exportExcel,
			tableForReports,
		},
		data() {
			return {
				showFilter: true,
				showReport: false,
				selectClients: [],
				selectedClient: [],
				fieldsTableReport: [
					{
						key: 'sendingDate',
						label: 'Fecha de Envío',
						//thStyle: 'width: 200px;'
					},
					{
						key: 'requestType',
						label: 'Tipo de Envío',
						//thStyle: 'width: 160px;'
					},
					{
						key: 'userName',
						label: 'Usuario Encargado',
					},
					{
						key: 'status',
						label: 'Estatus',
					},
				],
				tableForReport: [],
				dataToExport: [],
				totalRows: 0,
				dismissSecs: 10,
				dismissCountDown: 0,
			};
		},
		created() {
			//this.loadClients()
		},
		methods: {
			showAlert() {
				this.dismissCountDown = this.dismissSecs;
			},
			loadClients() {
				let loader = this.$loading.show();
				functionsReports
					.getFreeClients()
					.then((response) => {
						this.freeClients = response;
						this.selectClients = response;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			getRequestType: function(codType) {
				let requestType = '';
				switch (codType) {
					case 'S':
						requestType = 'Envío Individual';
						break;
					default:
						requestType = 'Envío Masivo';
						break;
				}
				return requestType;
			},
			search(input) {
				return new Promise((resolve) => {
					if (input.length < 3) {
						return resolve([]);
					}
					functionsReports
						.getClientsAutocomplete(encodeURI(input))
						.then((response) => {
							resolve(response);
						})
						.catch((error) => {
							console.log(error);
						});
				});
			},
			getResultValue(result) {
				return result.nombre_comercial;
			},
			onSubmit(result) {
				console.log(result);
				this.generateReport(result.codigoempresa);
			},
			generateReport(idClient) {
				let loader = this.$loading.show();
				//let idClient = this.selectedClient.codigoempresa
				functionsReports
					.getDetailsClient(idClient)
					.then((response) => {
						console.log(response);
						if (response.length == 0) {
							this.showAlert();
						}
						this.totalRows = response.length;
						let statusDescription = '';
						for (let index = 0; index < response.length; index++) {
							statusDescription =
								response[index].status.description !== ''
									? ' (' +
									  response[index].status.description +
									  ')'
									: '';
							this.tableForReport[index] = {
								sendingDate:
									response[index].request.sendingDate,
								requestType: this.getRequestType(
									response[index].request.requestType
								),
								userName: response[index].user.name,
								idUser: response[index].user.idUsers,
								status:
									response[index].status.name +
									statusDescription,
								_rowVariant: '',
							};
							this.dataToExport[index] = {
								'Fecha de Envío':
									response[index].request.sendingDate,
								'Tipo de Envío': this.getRequestType(
									response[index].request.requestType
								),
								'Usuario Encargado': response[index].user.name,
								Estatus:
									response[index].status.name +
									statusDescription,
							};
						}
						if (this.tableForReport.length > 0) {
							this.showReport = true;
							this.showFilter = false;
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(() => {
						loader.hide();
					});
			},
			generateNewReport() {
				this.showReport = false;
				this.showFilter = true;
				this.tableForReport = [];
				this.dataToExport = [];
			},
		},
	};
</script>

<style lang="scss" scoped></style>
